import { useState } from 'react';
import { Modal, ModalHeader, Input, ModalBody, Button } from 'reactstrap';

const FundPrizePoolModal = ({
  onClose,
  onSubmit,
  title,
  description,
  submitText,
}: {
  onClose: () => void;
  onSubmit: (amount: number) => void;
  title: string;
  description: string;
  submitText: string;
}) => {
  const [amount, setAmount] = useState(0);

  const handleSubmit = () => {
    onSubmit(amount);
  };

  return (
    <Modal isOpen toggle={onClose} id="fund-tournament-prize-pool-modal" className="modal-md" centered>
      <ModalHeader toggle={onClose}>{title}</ModalHeader>
      <ModalBody className="d-flex flex-column gap-4">
        <p className="mb-0">{description}</p>
        <Input
          value={Number(amount).toString()}
          onChange={(e) => {
            const acceptedInput = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.'];
            if (
              e.target.value
                .toString()
                .split('')
                .every((char) => acceptedInput.includes(char))
            ) {
              setAmount(Number(e.target.value));
            }
          }}
          min={0}
          type="number"
          placeholder="Amount"
        />
        <Button disabled={amount === 0} color="primary" onClick={handleSubmit}>
          {submitText}
        </Button>
      </ModalBody>
    </Modal>
  );
};

export default FundPrizePoolModal;
